module.exports = __webpack_public_path__ + "22f427cbd3a9c35c22c90c9748a7775c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/diver-helmet-s.png
// module id = 2660
// module chunks = 0